import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class CenterTypesMapperError extends IncError {
    constructor() {
        super(i18n.t("error:beneficiary.centerTypes.centerTypesMapperError"));

        Object.setPrototypeOf(this, CenterTypesMapperError.prototype);
    }
}